const md = window.matchMedia("(min-width: 768px)");

document.querySelectorAll(".accordion-tabs:not(.is-admin)").forEach((block) => {
    const isSingle     = block.classList.contains("accordion-tabs--single");
    const items        = block.querySelectorAll(".accordion-tabs__item");
    const images       = block.querySelectorAll(".accordion-tabs__right figure");
    const desktopVideos = block.querySelectorAll(".accordion-tabs__right video");

    function playVideo(index) {
        if (isSingle) return;
        desktopVideos.forEach((video, j) => {
            if (j === index) {
                video.play().catch(() => {});
            } else {
                video.pause();
                video.currentTime = 0;
            }
        });
    }

    function pauseAllVideos() {
        if (isSingle) return;
        desktopVideos.forEach((video) => {
            video.pause();
            video.currentTime = 0;
        });
    }

    function openItem(detail, index) {
        if (md.matches) {
            items.forEach((d, j) => { if (j !== index && d.open) closeItem(d); });
        }
        detail.setAttribute("open", "");
        requestAnimationFrame(() => detail.classList.add("is-open"));

        if (!isSingle) {
            images.forEach((img, j) => img.classList.toggle("active", j === index));
            playVideo(index);
        }

        if (!md.matches && !isSingle) {
            const mobileVideo = detail.querySelector(".accordion-tabs__img--mobile video");
            if (mobileVideo) mobileVideo.play().catch(() => {});
        }
    }

    function closeItem(detail) {
        const body = detail.querySelector(".accordion-tabs__item-body");
        detail.classList.remove("is-open");
        detail.classList.add("is-closing");

        if (!isSingle) {
            const mobileVideo = detail.querySelector(".accordion-tabs__img--mobile video");
            if (mobileVideo) mobileVideo.pause();
        }

        let done = false;
        const cleanup = () => {
            if (done) return;
            done = true;
            detail.classList.remove("is-closing");
            detail.removeAttribute("open");

            if (![...items].some((d) => d.open)) pauseAllVideos();
        };

        body.addEventListener("transitionend", cleanup, { once: true });
        setTimeout(cleanup, 500);
    }

    items.forEach((detail, i) => {
        if (detail.open) detail.classList.add("is-open");

        detail.querySelector("summary").addEventListener("click", (e) => {
            e.preventDefault();
            if (detail.open && !detail.classList.contains("is-closing")) {
                closeItem(detail);
            } else if (!detail.open) {
                openItem(detail, i);
            }
        });
    });

    if (isSingle) {
        // Single mode: desktop video plays continuously, mobile video autoplays via HTML attr
        const singleDesktopVideo = block.querySelector(".accordion-tabs__right video");
        if (singleDesktopVideo) singleDesktopVideo.play().catch(() => {});

        if (!md.matches) {
            const singleMobileVideo = block.querySelector(".accordion-tabs__img--mobile video");
            if (singleMobileVideo) singleMobileVideo.play().catch(() => {});
        }
    } else {
        // Per-item mode: autoplay video for the initially open item
        const firstActiveVideo = block.querySelector(".accordion-tabs__right figure.active video");
        if (firstActiveVideo) firstActiveVideo.play().catch(() => {});

        if (!md.matches) {
            const firstOpen = block.querySelector(".accordion-tabs__item[open]");
            if (firstOpen) {
                const mobileVideo = firstOpen.querySelector(".accordion-tabs__img--mobile video");
                if (mobileVideo) mobileVideo.play().catch(() => {});
            }
        }
    }

    // Play/pause toggle buttons (both modes)
    block.querySelectorAll(".accordion-tabs__video-toggle").forEach((button) => {
        const wrap  = button.closest(".accordion-tabs__video-wrap");
        const video = wrap.querySelector("video");

        button.addEventListener("click", () => {
            if (video.paused) {
                video.play();
                wrap.classList.remove("paused");
            } else {
                video.pause();
                wrap.classList.add("paused");
            }
        });
    });

    // Enable transitions after init to avoid animation on page load
    requestAnimationFrame(() => {
        requestAnimationFrame(() => block.classList.add("accordion-tabs--animated"));
    });
});
